import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useToastStore } from "../../lib/toastStore";
import { Icon } from "../primitives/Icon";
const VARIANT_ICON = {
    success: "check-circle",
    error: "circle-alert",
    info: "info",
    warning: "circle-alert",
};
/**
 * Global toast renderer. Mount once per app (Till + Manager) at the React
 * root — the underlying zustand store is module-singleton, so any caller
 * anywhere can fire `toast.error("…")` and this component will render it.
 */
export function Toaster() {
    const toasts = useToastStore((s) => s.toasts);
    const dismiss = useToastStore((s) => s.dismiss);
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: "toaster", role: "region", "aria-label": "Notifications", children: toasts.map((t) => (_jsx(ToastItem, { toast: t, onDismiss: () => dismiss(t.id) }, t.id))) }));
}
function ToastItem({ toast, onDismiss }) {
    useEffect(() => {
        if (toast.duration <= 0)
            return;
        const id = window.setTimeout(onDismiss, toast.duration);
        return () => window.clearTimeout(id);
    }, [toast.duration, onDismiss]);
    const isUrgent = toast.variant === "error" || toast.variant === "warning";
    return (_jsxs("div", { className: `toast toast-${toast.variant}`, role: isUrgent ? "alert" : "status", "aria-live": isUrgent ? "assertive" : "polite", children: [_jsx(Icon, { name: VARIANT_ICON[toast.variant], size: "sm", className: "toast-icon" }), _jsx("span", { className: "toast-message", children: toast.message }), _jsx("button", { type: "button", className: "toast-close", onClick: onDismiss, "aria-label": "Dismiss", children: _jsx(Icon, { name: "x", size: "sm" }) })] }));
}
//# sourceMappingURL=Toaster.js.map